import { getAbnormalExport, getAbnormalList, getAbnormalLogList } from '@/services/abnormal/abnormalQuery'
import { getConfigQuery } from '@/services/orderQuery/byBatch'
import { Button, Card, Checkbox, Modal, message } from 'antd'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
import AppendixThumbs from '@/pages/abnormal/components/AppendixThumbs'

import {
  dateFormatYearMonthDay,
  // downloadTemplate,
  formatEndTime,
  formatMessage,
  formatStartTime,
  initCurryingObj,
  paginationInit,
  uniqueFun
} from '@/utils/common'
import { WORK_ORDER_STATUS } from '@/utils/types'
let statusObj = initCurryingObj(WORK_ORDER_STATUS)
let platformSourceObj = []
const AbnormalQueryPage = props => {
  const mounting = useRef(false)
  let formRef = useRef(null)
  const [tableList, setTableList] = useState([])
  const [tableListDetail, setTableListDetail] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [selectItem, setSelectItem] = useState({})
  const [pagination, setPagination] = useState(paginationInit)

  let searchListInit = [
    {
      type: 'select',
      label: 'languageObj.abnormalQuery.platformSource',
      key: 'platformSource',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      // maxTagTextLength: 10,
      showAll: true,
      selectList: []
    },
    {
      type: 'timeRange',
      label: 'languageObj.abnormalQuery.creatDate',
      key: 'creatDate',
      showRangePresets: true,
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > moment().endOf('day')
        return falg
      },
      initialValues: []
    },
    {
      type: 'select',
      label: 'languageObj.abnormalQuery.status',
      key: 'status',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      showAll: true,
      selectList: WORK_ORDER_STATUS
    },
    {
      type: 'select',
      label: 'languageObj.abnormalQuery.cause',
      key: 'exceptionalType',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      showAll: true,
      selectList: []
    },
    {
      type: 'textArea',
      label: 'languageObj.abnormalQuery.returnNum',
      key: 'trackingNo',
      autoSize: { minRows: 3, maxRows: 3 },
      initialValues: '',
      placeholder: formatMessage('languageObj.abnormalQuery.placeholderFormat')
    },
    {
      type: 'textArea',
      label: 'languageObj.abnormalQuery.abnormalNum',
      key: 'wmsBillCode',
      autoSize: { minRows: 3, maxRows: 3 },
      initialValues: '',
      placeholder: formatMessage('languageObj.abnormalQuery.placeholderFormat')
    },
    {
      type: 'select',
      label: 'languageObj.abnormalQuery.csHandleType',
      key: 'csHandleType',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      showAll: true,
      selectList: []
    },
    {
      type: 'select',
      label: 'languageObj.abnormalQuery.csHandleSubType',
      key: 'csHandleSubType',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      showAll: true,
      selectList: []
    },
    {
      type: 'textArea',
      label: 'languageObj.abnormalQuery.productCode',
      key: 'productCode',
      autoSize: { minRows: 4, maxRows: 4 },
      initialValues: '',
      placeholder: formatMessage('languageObj.abnormalQuery.placeholderFormat2')
    },
    {
      type: 'select',
      label: 'languageObj.abnormalQuery.gradeName',
      key: 'gradeList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      showAll: true,
      selectList: []
    },
    {
      type: 'select',
      label: 'languageObj.abnormalQuery.wmsHandleResult',
      key: 'wmsHandleTypeList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      showAll: true,
      selectList: []
    }
  ]
  let searchListInitDetail = [
    {
      type: 'text',
      label: 'languageObj.abnormalQuery.abnormalNum',
      initialValues: selectItem.wmsBillCode,
      spans: {
        xl: { flex: '20%' },
        xxl: { flex: '20%' }
      },
      itemCol: {
        labelCol: {
          span: 10
        },
        wrapperCol: {
          span: 14
        }
      }
    },
    {
      type: 'text',
      label: 'languageObj.abnormalQuery.returnTrackingNum',
      initialValues: selectItem.trackingNo,
      spans: {
        xl: { flex: '20%' },
        xxl: { flex: '20%' }
      },
      itemCol: {
        labelCol: {
          span: 12
        },
        wrapperCol: {
          span: 12
        }
      }
    },
    {
      type: 'text',
      label: 'languageObj.abnormalQuery.currentWorkStatus',
      initialValues: statusObj[selectItem.status],
      spans: {
        xl: { flex: '20%' },
        xxl: { flex: '20%' }
      },
      itemCol: {
        labelCol: {
          span: 12
        },
        wrapperCol: {
          span: 12
        }
      }
    },
    {
      type: 'text',
      label: 'languageObj.abnormalQuery.platformChannel',
      initialValues: selectItem.platformSource,
      spans: {
        xl: { flex: '20%' },
        xxl: { flex: '20%' }
      },
      itemCol: {
        labelCol: {
          span: 8
        },
        wrapperCol: {
          span: 16
        }
      }
    },
    {
      type: 'text',
      label: 'languageObj.abnormalQuery.shopName',
      initialValues: selectItem.shopName,
      spans: {
        xl: { flex: '20%' },
        xxl: { flex: '20%' }
      },
      itemCol: {
        labelCol: {
          span: 8
        },
        wrapperCol: {
          span: 16
        }
      }
    }
  ]

  const [searchList, setSearchList] = useState(searchListInit)
  const [checkboxVal, setCheckboxVal] = useState(false)
  // 查询标志
  const [queryFlag, setQueryFlag] = useState(false)
  // const [pagination] = useState(paginationInit)
  const tableColumns = [
    {
      title: formatMessage('languageObj.abnormalQuery.abnormalNum'),
      dataIndex: 'wmsBillCode',
      width: 150,
      fixed: 'left',
      render: (text, record) => {
        return (
          <div
            className="link_name word_break_all"
            onClick={() => {
              tableItemClick(record)
            }}
          >
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.appendix'),
      dataIndex: 'appendix',
      width: 300,
      render: (_, record) => {
        const raw = Array.isArray(record?.attachList) ? record.attachList : []

        // 后端 attachType 可能是 'PICTORY' / 'VIDEO' 或数字码；统一转成 'image' / 'video'
        const attachments = raw
          .filter(item => item && item.attachUrl) // 过滤掉缺失数据
          .map(item => ({
            src: item.attachUrl,
            type: normalizeType(item.attachType), // 见下方工具函数
            name: item.attachDescription, // 可用于下载文件名
            retakeFlag: !!item.retakeFlag, // ✅ 补拍标识
            retakeId: item.retakeId // ✅ 可选，后面需要可用
          }))

        /** props:
         * attachments: Array<{ src: string, type: 'image'|'video', name?: string, retakeFlag?: boolean, retakeId?: number }>
         * maxShow?: number (默认 6)
         */
        return <AppendixThumbs attachments={attachments} maxShow={6} />
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.workStatus'),
      dataIndex: 'status',
      width: 100,
      render: text => {
        return <div className="word_break_all">{statusObj[text]}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.workRegistrationTime'),
      dataIndex: 'checkedTime',
      width: 150,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.returnTrackingNum'),
      dataIndex: 'trackingNo',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.exception'),
      dataIndex: 'exceptionalType',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.platformChannel'),
      dataIndex: 'platformSource',
      width: 100,
      render: text => {
        let res = initFlatformSource(text)
        return <div className="word_break_all">{res}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.omsReturnInstruction'),
      dataIndex: 'returnOrderCode',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.platformReturnInstruction'),
      dataIndex: 'platformReturnCode',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.abnormalWorkLineNum'),
      dataIndex: 'lineId',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.productCode'),
      dataIndex: 'productCode',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.size'),
      dataIndex: 'size',
      width: 60,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.qualityResults'),
      dataIndex: 'grade',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.csHandleType'),
      dataIndex: 'csHandleTypeStr',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.csHandleSubType'),
      dataIndex: 'csHandleSubTypeStr',
      width: 140,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.wmsHandleResult'),
      dataIndex: 'wmsHandleTypeStr',
      width: 110,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.wmsCloseTime'),
      dataIndex: 'wmsCloseTime',
      width: 105,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]

  function normalizeType(t) {
    if (!t) return 'image'
    const s = String(t).toUpperCase()
    if (s.includes('2')) return 'video'
    // 其他均按图片处理
    return 'image'
  }

  const initFlatformSource = str => {
    let res = []
    // console.log(str)
    if (str) {
      let ls = str.split(',')
      for (let index = 0; index < ls.length; index++) {
        const element = ls[index]
        res.push(platformSourceObj[element])
      }
    }
    return res.join(',')
  }
  const tableColumnsDetail = [
    {
      title: formatMessage('languageObj.abnormalQuery.operatingTime'),
      dataIndex: 'operationTime',
      width: 150,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.operationalState'),
      dataIndex: 'status',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.lineName'),
      dataIndex: 'lineId',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.abnormalCause'),
      dataIndex: 'exceptionalType',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.operator'),
      dataIndex: 'operation',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.reveiver'),
      dataIndex: 'receiver',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.remark'),
      dataIndex: 'remark',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.isClose'),
      dataIndex: 'closedStr',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.isVoided'),
      dataIndex: 'invalidStr',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.operationalEvent'),
      dataIndex: 'event',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.csHandleSubType'),
      dataIndex: 'csHandleSubTypeStr',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.abnormalQuery.operationResult'),
      dataIndex: 'handleType',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]
  useEffect(() => {
    if (mounting.current) {
      searchDataFun()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    // 获取店铺
    getConfigQueryFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    mounting.current = true
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    formRef && formRef.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  // 获取下拉框数据
  const getConfigQueryFun = () => {
    Promise.all([
      getConfigQuery({ configType: 'bytenew_problem_type' }),
      getConfigQuery({ configType: 'cs_handle_type' }),
      getConfigQuery({ configType: 'cs_handle_sub_type' }),
      getConfigQuery({ configType: 'abnormal_send_api_config' }),
      getConfigQuery({ configType: 'wms_handle_type' }),
      getConfigQuery({ configType: 'arl_defect_reasons' })
    ]).then(res => {
      try {
        searchListInit.forEach(itemFirst => {
          if (
            itemFirst.key === 'exceptionalType' ||
            itemFirst.key === 'csHandleType' ||
            itemFirst.key === 'csHandleSubType' ||
            itemFirst.key === 'platformSource' ||
            itemFirst.key === 'wmsHandleTypeList' ||
            itemFirst.key === 'gradeList'
          ) {
            let uniqueRes = []
            switch (itemFirst.key) {
              case 'exceptionalType':
                let data = res[0].resultData || []
                for (let index = 0; index < data.length; index++) {
                  const element = data[index]
                  uniqueRes.push({
                    label: element.configKey,
                    value: element.configKey
                  })
                }
                break
              case 'csHandleType':
                let data1 = res[1].resultData || []
                for (let index = 0; index < data1.length; index++) {
                  const element = data1[index]
                  uniqueRes.push({
                    label: element.configValue,
                    value: element.configKey
                  })
                }
                break
              case 'csHandleSubType':
                let data2 = res[2].resultData || []
                for (let index = 0; index < data2.length; index++) {
                  const element = data2[index]
                  uniqueRes.push({
                    label: element.configValue,
                    value: element.configKey
                  })
                }
                break
              case 'platformSource':
                let data3 = res[3].resultData || []
                for (let index = 0; index < data3.length; index++) {
                  const element = data3[index]
                  uniqueRes.push({
                    label: element.description,
                    value: element.configKey
                  })
                }

                // platformSourceObj = uniqueRes;

                platformSourceObj = (uniqueRes || []).reduce((acc, cur) => {
                  acc[cur.value] = cur.label
                  return acc
                }, {})

                // console.log(platformSourceObj)
                break
              case 'wmsHandleTypeList':
                let data4 = res[4].resultData || []
                for (let index = 0; index < data4.length; index++) {
                  const element = data4[index]
                  uniqueRes.push({
                    label: element.configValue,
                    value: element.configKey
                  })
                }
                uniqueRes.push({
                  label: '空', // 或者 '' / '请选择'
                  value: '-1'
                })
                break
              case 'gradeList':
                let data5 = res[5].resultData || []
                for (let index = 0; index < data5.length; index++) {
                  const element = data5[index]
                  uniqueRes.push({
                    label: element.configValue,
                    value: element.configKey
                  })
                }
                uniqueRes.push({
                  label: '空', // 或者 '' / '请选择'
                  value: 'null'
                })
                break
              default:
                uniqueRes = []
                break
            }
            let unique = uniqueFun(uniqueRes)
            itemFirst.selectList = unique
          }
        })
        setSearchList([...searchListInit])
      } catch (error) {
        console.log(error)
      }
    })
  }
  const getSearchInfo = () => {
    let info = {}
    info = (formRef.current && formRef.current.getValue()) || {}
    let trackingNo = info.trackingNo ? info.trackingNo.split('\n').filter(Boolean) : []
    let wmsBillCode = info.wmsBillCode ? info.wmsBillCode.split('\n').filter(Boolean) : []
    let productCode = info.productCode ? info.productCode.split('\n').filter(Boolean) : []

    let createStartTime = formatStartTime(info.creatDate)
    let createEndTime = formatEndTime(info.creatDate)
    const params = {
      ...info,
      trackingNo: trackingNo.join(','),
      wmsBillCode: wmsBillCode.join(','),
      productCode: productCode.join(','),
      exceptionalType: info.exceptionalType,
      platformSource: info.platformSource,
      createStartTime: createStartTime,
      createEndTime: createEndTime
    }
    if (checkboxVal) {
      params.includeLog = true
    }
    delete params.creatDate
    return params
  }
  const searchDataFun = () => {
    let info = getSearchInfo()
    const params = {
      ...info,
      size: pagination.pageSize,
      page: pagination.currentPage
    }
    getAbnormalList(params).then(res => {
      const dt = res.resultData
      const records = dt.records
      setTableList(records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }
  // 分页查询
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  // 导出结果
  const downLoadFun = () => {
    let info = getSearchInfo()
    const params = {
      ...info
    }
    getAbnormalExport(params).then(res => {
      message.success(formatMessage('languageObj.byBatchLocale.downloadTip'))
    })
  }
  const onCheckboxChange = e => {
    setCheckboxVal(e.target.checked)
  }
  const tableItemClick = record => {
    setSelectItem({ ...record, platformSource: initFlatformSource(record.platformSource) })
    setModalVisible(true)
    getAbnormalLogListFun(record)
  }
  const handleModalCancel = () => {
    setModalVisible(false)
  }

  const handleModalOk = () => {
    setModalVisible(false)
  }
  const getAbnormalLogListFun = record => {
    const params = {
      wmsBillCode: record.wmsBillCode,
      lineId: record.lineId
    }
    getAbnormalLogList(params).then(res => {
      const dt = res.resultData
      setTableListDetail(dt)
    })
  }
  return (
    <div>
      <Card>
        <div className="search-bar">
          <SearchBar ref={formRef} searchList={searchList}></SearchBar>
          <div className="mt10">
            <div className="right_search">
              <Button type="primary" onClick={searchDataBtn}>
                {formatMessage('languageObj.commonLocale.search')}
              </Button>
              <Button onClick={searchClearDataBtn}>{formatMessage('languageObj.commonLocale.clear')}</Button>
              <Button type="primary" onClick={downLoadFun}>
                {formatMessage('languageObj.abnormalQuery.exportResults')}
              </Button>
              <Checkbox className="ml10 defaultColor" checked={checkboxVal} onChange={onCheckboxChange}>
                {formatMessage('languageObj.abnormalQuery.downloadCheckBox')}
              </Checkbox>
            </div>
          </div>
        </div>
      </Card>

      <Card className="mt15">
        <div className="content-container">
          <div>
            <AntdTable
              title={() => (
                <div>
                  <div className="defaultColor">{formatMessage('languageObj.abnormalQuery.tableTitle')}</div>
                </div>
              )}
              dataSource={tableList}
              columns={tableColumns}
              pagination={pagination}
              // pagination={false}
              onChange={handleTableChange}
              scroll={{
                // y: '75vh',
                x: '170%'
              }}
            />
          </div>
        </div>
      </Card>
      <Modal
        open={modalVisible}
        // destroyOnClose={true}
        className="nike_modal"
        width="85%"
        title={formatMessage('languageObj.abnormalQuery.history')}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        footer={null}
      >
        <div className="mb15">
          <SearchBar formLayout={{ colon: true }} searchList={searchListInitDetail}></SearchBar>
        </div>
        <AntdTable
          dataSource={tableListDetail}
          columns={tableColumnsDetail}
          pagination={false}
          scroll={{
            y: '55vh',
            x: '100%'
          }}
          // onChange={handleTableChange}
        />
      </Modal>
    </div>
  )
}
export default AbnormalQueryPage
